<footer class="footer" [style.background-color]="headerParamsService.footerColour()">
  <div class="footer-container">
    <nav class="footer-nav">
      @if (!headerParamsService.isElevenPlus()) {
        <a routerLink="/cookies">Cookies</a>
        <a routerLink="/privacy">Privacy</a>
      }
    </nav>
  </div>
</footer>
